import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import bg from "../../assets/throne-extended.jpg";
import { events } from '../../events'; // Import the events array

const Register = () => {
  const { eventName } = useParams(); // Extract the eventName from URL parameters
  const [event, setEvent] = useState(null);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const selectedEvent = events.find(e => e.path.includes(eventName)); // Find the event based on the URL parameter
    setEvent(selectedEvent);

    if (selectedEvent) {
      const initialFormData = selectedEvent.formfields.reduce((acc, field) => {
        acc[field.id] = '';
        return acc;
      }, {});
      setFormData(initialFormData);
    }
  }, [eventName]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (event) {
      event.formfields.forEach(field => {
        if (!formData[field.id]) {
          newErrors[field.id] = `${field.label} is required`;
        }
      });

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      try {
        await fetch('http://localhost:3001/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  return (
    <div
      className="h-screen w-screen overflow-y-scroll snap-y snap-mandatory scroll-smooth"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'local',
        backgroundPosition: 'center top',
      }}
    >
      <section className="h-screen w-full snap-start flex items-center justify-center backdrop-blur-sm transition-transform delay-75 duration-1000">
        <div className="text-center">
          <h1 className="text-7xl font-bold m-4 p-7 text-slate-600 text-stroke tracking-widest">Register</h1>
        </div>
      </section>

      <section className="h-screen w-full snap-start flex items-center justify-center backdrop-blur-sm transition-transform delay-75 duration-1000">
        <div className="bg-black bg-opacity-60 p-8 rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0">
          {event ? (
            <form onSubmit={handleSubmit}>
              {event.formfields.map(field => (
                <div key={field.id} className="mb-4">
                  <label htmlFor={field.id} className="block text-white text-m font-medium mb-2">{field.label}</label>
                  <input
                    type={field.type}
                    id={field.id}
                    value={formData[field.id]}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-black bg-opacity-30 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={field.placeholder}
                  />
                  {errors[field.id] && <p className="text-red-500 text-xs">{errors[field.id]}</p>}
                </div>
              ))}
              <button
                type="submit"
                className="w-[max-content] flex justify-around px-4 py-2 bg-slate-500 text-white rounded-lg hover:bg-slate-600 transition-all"
              >
                Submit
              </button>
            </form>
          ) : (
            <p>Loading event details...</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Register;
